//Reset data
export const RESET = "DOSSIER_SHOW_RESET"

//Loading
export const SET_TOGGLE_LOADING = "DOSSIER_SHOW_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "DOSSIER_SHOW_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "DOSSIER_SHOW_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "DOSSIER_SHOW_SET_MESSAGE"
export const SET_IS_SUCCESS = "DOSSIER_SHOW_SET_IS_SUCCESS"
export const SET_IS_ERROR = "DOSSIER_SHOW_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "DOSSIER_SHOW_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "DOSSIER_SHOW_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "DOSSIER_SHOW_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "DOSSIER_SHOW_SET_ITEMS"
export const SET_CURRENT_ITEM = "DOSSIER_SHOW_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "DOSSIER_SHOW_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "DOSSIER_SHOW_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "DOSSIER_SHOW_SET_HIDE_MODAL"


export const SET_MODAL = "DOSSIER_SHOW_SET_MODAL"
export const SET_MODAL_CONTENT = "DOSSIER_SHOW_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "DOSSIER_SHOW_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "DOSSIER_SHOW_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "DOSSIER_SHOW_SET_MODAL_TYPE"